import { Alert, AlertDescription } from "@babackapp/customer-ui/components/alert";
import { InfoIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { TextDto } from "@babackapp/private-api-client";

type Props = {
  texts?: TextDto[] | null;
};

function pickText(texts: TextDto[], lang: string): string | null {
  const langPrefix = lang.split("-")[0].toLowerCase();
  const match =
    texts.find((t) => t.lang.toLowerCase() === lang.toLowerCase()) ??
    texts.find((t) => t.lang.toLowerCase().startsWith(langPrefix)) ??
    texts[0];
  const text = match?.text?.trim();
  if (!text || text === "<p></p>" || text === "<p><br></p>") return null;
  return text;
}

export function UserPortalCallout({ texts }: Props) {
  const { i18n } = useTranslation("return-widget-v3");

  if (!texts?.length) return null;

  const text = pickText(texts, i18n.language ?? "en");
  if (!text) return null;

  return (
    <Alert variant="info">
      <InfoIcon />
      <AlertDescription dangerouslySetInnerHTML={{ __html: text }} />
    </Alert>
  );
}
